module.exports = __webpack_public_path__ + "img/CACADOR.61f7d8a6.jpg";